module.exports = __webpack_public_path__ + "img/fluffy_hat.caead6ec.png";